import {Project} from '../project/project';
import {TranslateService} from '@ngx-translate/core';
import {ChipSourceItem} from '@mydocma/component-library/src/lib/chips/chip-item';

export interface Companies {
  Data: Company[];
  Count: number;
}

export interface Company {
  Id?: number;
  Parent?: Company;
  Uid?: string;
  SUid?: string;
  Project?: Project;
  ShortName?: string;
  Name1?: string;
  Name2?: string;
  Supplier?: string;
  Street?: string;
  ZipCode?: string;
  City?: string;
  Country?: string;
  POBox?: string;
  ZipCodePOBox?: string;
  CityPOBox?: string;
  Phone?: string;
  Fax?: string;
  Email?: string;
  EmailSourceItems?: ChipSourceItem[];
  Web?: string;
  IsInsolvent?: boolean;
  IsActive?: boolean;
  inactive?: boolean; /* internal fields for company-grid!! */
  UsePOBoxAsAddress?: boolean;
  IsDeleted?: boolean;
  ViewPoint?: number;

  isChecked?: boolean;
}

export function getCompanyInfo(c: Company, translateService: TranslateService) {
  if (c.IsDeleted) {
    return ' ' + translateService.instant('MM.general.deleted');
  }
  if (!c.IsActive || c.IsInsolvent) {
    return ' ' + translateService.instant('MM.general.inactive');
  }
  return '';
}


